/** @jsx jsx */
import { jsx, Box, Container } from "theme-ui";
import { rgba } from "polished";
import SectionHeading from "components/section-heading";
import Service from "components/cards/service";
import icon1 from "assets/images/icons/service1.png";
import icon2 from "assets/images/icons/service2.png";
import icon3 from "assets/images/icons/service3.png";
import ReactPlayer from "react-player";

const data = [
  {
    id: 1,
    icon: icon1,
    title: "Optimized collection routes",
    description: `Save hundreds of thousands in vehicle and labour costs with smart collection times and routes`,
  },
  {
    id: 3,
    icon: icon2,
    title: "Useful analytics",
    description: `Know where to place your bins and anticipate any waste crisis with smart predictions`,
  },
  {
    id: 4,
    icon: icon3,
    title: "Real-time monitoring",
    description: `Reestablish your strategies with interactive graphs or live maps and be quick to intervene`,
  },
];

const Services = () => {
  return (
    <Box as="section" id="services" sx={styles.section}>
      <Container>
        <SectionHeading
          sx={styles.heading}
          title="A step closer to a smart and green city"
          description="Automate your garbage collection workflows with customized collection strategies for each neighborhood"
        />
        <Box sx={styles.contentWrapper}>
          {data?.map((item) => (
            <Service key={item.id} item={item} />
          ))}
        </Box>
        <Box sx={styles.contentWrapper2}>
        <Box sx={styles.video}>
          <ReactPlayer
            url="https://www.youtube.com/watch?v=TA9EJoOphlo"
            style={{ maxWidth: "90vw" }}
            config={{
              youtube: {
                playerVars: { fs: 1, modestbranding: 1, controls: 1 },
              },
              facebook: {
                appId: "12345",
              },
            }}
          />
        </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Services;

const styles = {
  section: {
    backgroundColor: rgba("#FFF5ED", 0.5),
    pt: [11, 11, 11, 12, 12, 12, 14],
    pb: [7, 7, 7, 9, 9, 10, 11],
  },
  heading: {
    maxWidth: [null, null, null, 455, 660],
    mb: [6, null, null, 8, null, 9, 13],
  },
  contentWrapper: {
    gap: 30,
    display: "grid",
    justifyContent: ["center", null, null, "unset"],
    gridTemplateColumns: [
      "repeat(1, 285px)",
      "repeat(1, 325px)",
      "repeat(1, 285px)",
      "repeat(3, 1fr)",
    ],
  },
  contentWrapper2: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  video: {
    maxWidth: ["100%"],
    paddingTop: "10%",
    alignItems: "middle",
    textAlign: "center",
  },
};
